// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/index.json";
import gu from "./locales/gu/index.json";
import hi from "./locales/hi/index.json";

// `name` is the language's own name, read by screen readers on the switch buttons
export const LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "hi", label: "HI", name: "हिन्दी" },
  { code: "gu", label: "GU", name: "ગુજરાતી" },
];

// Always start in English so the client's first render matches the
// statically generated HTML; LanguageDetectorWrapper switches language
// after hydration.
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    gu: { translation: gu },
  },
  fallbackLng: "en",
  lng: "en",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
